// export var firebaseConfig = {
//     apiKey: "AIzaSyC274vRHOj_7uaR--ciA98ux6EzEpNAH08",
//     authDomain: "bancoteste-4e507.firebaseapp.com",
//     databaseURL: "https://bancoteste-4e507.firebaseio.com",
//     projectId: "bancoteste-4e507",
//     storageBucket: "bancoteste-4e507.appspot.com",
//     messagingSenderId: "952834732091",
//     appId: "1:952834732091:web:7262e9d9b43c790072ec1e"
// }

// Oficial GGTIC
export var firebaseConfig = {
  apiKey: "AIzaSyAQFQp1C6DT58m6fHQF3ndd0C7lWSU07rs",
  authDomain: "ggtic-2009a.firebaseapp.com",
  projectId: "ggtic-2009a",
  storageBucket: "ggtic-2009a.appspot.com",
  messagingSenderId: "176627939321",
  appId: "1:176627939321:web:b6cd5f5fbb62721bb76f28"
  };

export const auth0Config = {
    client_id: 'XmminWIs0S8gR3gIRBydYLWbF58x81vK',
    domain: 'matx.us.auth0.com',
}
